import styles from './OffersContainer.module.scss';
import { PriceBox } from '../PriceBox';
import { List } from '../../dataProvider';

type PriceBoxContainerProps = {
  offers: List[];
  userEntryCounts?: Record<string, number>;
  onShowEntries?: (list: List) => void;
};

export const OffersContainer = ({
  offers,
  userEntryCounts,
  onShowEntries,
}: PriceBoxContainerProps) => {
  return (
    <div className={styles.container}>
      {offers.map((offer) => (
        <PriceBox
          key={offer.id}
          offer={offer}
          entryCount={userEntryCounts?.[offer.id] || 0}
          onShowEntries={onShowEntries}
        />
      ))}
    </div>
  );
};
